import React from 'react'
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { InformationPage, OrderPage, ContainerOrderPage, SelectOrderPage, ContainerGeneralOrderPage } from './style'
import { language } from '../../utils/language';

const HeadPagination = ({ homeState, list, handleOrder, order = 'outstanding' , typeList, handleTypeList, isMobile, idCategory, showPaginationInformationOnMobile = false }: any) => {
    return (
        <ContainerGeneralOrderPage>
            {
                (!isMobile) &&
                <InformationPage>{language[homeState.default_language]["showing"]} {list.from} - {list.to} de {list.total} {language[homeState.default_language]["products"]}</InformationPage>
            }

            <ContainerOrderPage>
                {
                    idCategory !== 0 && (
                        <>
                            <OrderPage>{language[homeState.default_language]["sortBy"]}:</OrderPage>
                            <SelectOrderPage onChange={handleOrder}  >
                                <option value={'outstanding'}>{language[homeState.default_language]["featured"]}</option>
                                <option value={'date_desc'}>{language[homeState.default_language]["recent"]}</option>
                                <option value={'amount_asc'}>{language[homeState.default_language]["lowestFirst"]}</option>
                                <option value={'amount_desc'}>{language[homeState.default_language]["highestFirst"]}</option>
                            </SelectOrderPage>
                        </>
                    )
                }
                {
                    isMobile ? <>
                        <ViewListIcon style={{
                            fontSize: '30px',
                            color: typeList === 'row' ? homeState.color : '#999999',
                            cursor: 'pointer',
                            marginLeft: 'auto'
                        }}
                            viewBox="0 0 25 25"
                            onClick={() => handleTypeList('row')}
                        />
                        <ViewModuleIcon style={{
                            fontSize: '30px',
                            color: typeList === 'colum' ? homeState.color : '#999999',
                            cursor: 'pointer'
                        }}
                            onClick={() => handleTypeList('colum')}
                        />
                    </> :
                        <>
                            <ViewListIcon style={{
                                fontSize: '2.1875rem',
                                color: typeList === 'row' ? homeState.color : '#999999',                                                                
                                cursor: 'pointer',
                            }}
                                viewBox="0 0 25 25"
                                onClick={() => handleTypeList('row')}
                            />
                            <ViewModuleIcon style={{
                                fontSize: '2.1875rem',                                
                                color: typeList === 'colum' ? homeState.color : '#999999',
                                cursor: 'pointer'
                            }}
                                viewBox="0 0 24 24"
                                onClick={() => handleTypeList('colum')}
                            />
                        </>
                }
            </ContainerOrderPage>
            {
                (showPaginationInformationOnMobile && isMobile) &&
                <InformationPage>{language[homeState.default_language]["showing"]} {list.from} - {list.to} de {list.total} {language[homeState.default_language]["products"]}</InformationPage>
            }
        </ContainerGeneralOrderPage>
    )
}

export default HeadPagination